<template>
  <div>
    <Navbar></Navbar>
    <div class="content">
      <div class="section_1">
        <div class="_t title">
          <p>Detect the arrhythmia</p>
          <p>risk and mental stress</p>
          <p style="position: relative;">with Heart Smart<span style="font-size: 0.32rem;position: absolute;">™</span>  <span style="padding-left:0.2rem">heart</span></p>
          <p>monitor at anytime</p>
        </div>
        <div class="_p">No need to ship it back, it is yours!</div>
        <div class="img">
          <img src="@/assets/2.0/mobile/w_section_1.jpg" />
        </div>
      </div>
      <div class="section_3">
        <div class="_t title">
          <p>How it works</p>
        </div>
      </div>
      <div class="section_4">
        <div class="trait-list">
        <div class="trait-item">
          <div class="circle">1</div>
          <div class="text-box">
            <div class="title-text">Connect it</div>
            <div class="info-text">
              <p>Connect the monitor</p>
              <p>to cell phone</p>
            </div>
          </div>
          <div class="img-info"><img src="@/assets/2.0/icon-01.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">2</div>
          <div class="text-box">
            <div class="title-text">Wear it</div>
            <div class="info-text">
              <p>Wear the monitor patch</p>
              <p>to your chest</p>
            </div>
         </div>
          <div class="img-info" style="right: 0.23rem;"><img src="@/assets/2.0/icon-03.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">3</div>
          <div class="text-box">
            <div class="title-text">Use it</div>
            <div class="info-text">
              <p>Monitor your heart and</p>
              <p>stress at anytime</p>
            </div>
          </div>
          <div class="img-info" style="right:0.05rem;"><img src="@/assets/2.0/icon-02.svg" /></div>
        </div>
        <div class="trait-item">
          <div class="circle">4</div>
          <div class="text-box">
            <div class="title-text">Read it</div>
            <div class="info-text">
              <p>Download and read</p>
              <p>your report after</p>
            </div>
          </div>
          <div class="img-info" style="right:0.05rem;"><img src="@/assets/2.0/icon-04.svg" /></div>
        </div>
        </div>
      </div>

      <div class="section_5">
        <div class="_t">Download App today</div>
        <div class="_p">
          <p>The HMApp paired with the Micro allows you to</p>
          <p>check your heart status lively, log the data to server</p>
          <p>and perform analysis for you</p>
        </div>

      </div>
      <div class="section_6">
        <div class="img">
          <img src="@/assets/2.0/mobile/mobile.png" />
        </div>
        <div class="d-flex align-center justify-center img-list">
          <img src="@/assets/2.0/mobile/appstore.png" @click="download('ios')"/>
          <img src="@/assets/2.0/mobile/googleplay.png" @click="download('android')"/>
        </div>
      </div>
    </div>
    <FooterDom></FooterDom>
  </div>
</template>

<script>
import Navbar from "./components/navbar.vue";
import FooterDom from "./components/footerEle.vue";


export default {
  name: "index",
  components: { Navbar,FooterDom },
  data() {
    return {

    };
  },
  created() {

  },
  computed: {

  },
  mounted() {

  },
  methods: {
    download(type){
      const url = type ==="ios" ? process.env.VUE_APP_IOS_HOST : process.env.VUE_APP_ANDROID_HOST 
      window.open(url,'_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  font-size: 0;
  ._t {
    font-size: 0.7rem;
    color: #000;
  }
  ._p{
    font-size: 0.22rem;
    color: #000;
  }
  .img{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .section_1{
    background: #f5f5f5;
    padding:0.54rem 0.78rem;
    min-height: 10.8rem;
    width: 100%;
    position: relative;
    z-index: 2;
    ._t{
      font-size: 0.47rem;
      position: relative;
    z-index: 2;
    }
    ._p{
      margin: 0.2rem 0;
      position: relative;
    z-index: 2;
    }
    .img{
      position: absolute;
      top:0;
      left: 0;
      z-index: 1;
    }

  }
.section_3{
  padding: 0.78rem 0.78rem 0;
  .title{
    width: 100%;
    p{
      text-align: center;
    }
  }
}
  .section_4{
    background: #fff;
    // padding: 0.78rem;
    display: flex;
    align-items: center;
    .trait-list{
      width: 100%;
      padding: 0 0.78rem;
      .trait-item{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px dashed #4D4D4E;
        padding: 0.78rem 0.1rem 0.78rem 0;
        position: relative;
        &:last-child{
          border-bottom: none;
        }
        .circle{
          width: 0.57rem;
          height: 0.57rem;
          line-height: 0.57rem;
          font-size: 0.36rem;
          border: 0.5px solid #000;
          color: #000;
          border-radius: 0.57rem;
          text-align: center;
          margin-right: 0.78rem;
          font-family: "Light";
        }
        .text-box{
          margin-right: 20%;
          .title-text{
            font-size: 0.5rem;
            margin-bottom: 0.1rem;

          }
          .info-text{
            font-size: 0.26rem;
          }
        }
        .img-info{
          height: 1.02rem;
          position: absolute;
          right: 0.2rem;
          img{
            height: 100%;
          }
        }
      }
    }
  }
  .section_5{
    background: #f5f5f5;
    padding: 0.74rem;
    ._t{
      width: 100%;
      font-size: 0.6rem;
      text-align: center;
    }
    ._p{
      margin-top: 0.2rem;
      p{
        text-align: center;
      }
    }
  }
  .section_6{
    background: #f5f5f5;
    padding-top: 0.2rem;
    .img-list{
      padding: 0.84rem 0;

      img{
        width: 2.2rem;
        margin-right: 0.2rem;
        margin-bottom: 0.5rem;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/howWork.vue